import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { Button } from "sprout-ui-dom/dist/Button";
import { Portal } from "sprout-ui-dom/dist/Portal";
import { useCallback, useMemo } from "react";
import { Flex } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import { Cancel } from "sprout-ui-icons";
import { MenuItem } from "./Menu";
import { ACTIONS } from "./actionRegistry";
import { isActionValidForMultiselect } from "./utils";
import { useNavigationListContext } from ".";
const CancelButton = styled(Button)`
  position: absolute;
  z-index: 1;

  top: 8px;
  right: 12px;

  width: 24px;
  height: 24px;

  :not(:disabled) {
    :active {
      background: transparent;
    }
  }
`;
const breakpoint = "864px";
const MultiselectMenuWrapper = styled(Flex)`
  position: fixed;
  z-index: 101;

  gap: 8px;
  padding: 24px 16px 16px;

  ${media.down(breakpoint)} {
    flex-direction: column;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
  }

  ${media.up(breakpoint)} {
    top: 28px;
    left: 50%;
    right: 0;

    transform: translateX(-50%);
    width: calc(100% - 32px);
    max-width: 1060px;

    padding: 16px 40px 16px 16px;
  }
`;
const MultiselectMenuItemsWrapper = styled(Flex)`
  flex-direction: column;
  gap: 8px;

  ${media.up(breakpoint)} {
    flex-direction: row;
  }
`;
const MultiselectMenuItemsPills = styled(MultiselectMenuItemsWrapper)`
  ${media.up(breakpoint)} {
    flex-wrap: wrap;
  }
`;
const MenuItemTile = styled(MenuItem)`
  min-width: 100px;
`;
const MenuItemPill = styled(MenuItem)`
  max-height: 40px;
  width: auto;
`;
const DESIRED_ACTION_ORDER = [
    "WHEN",
    "ASSIGN",
    "SET_PRIORITY",
    "REMOVE_PRIORITY",
    "MOVE",
    "LABEL",
    "DEADLINE",
    "SET_COMPLETED",
    "SET_INCOMPLETE",
    "SET_DONE",
    "SET_SET_ASIDE",
    "ARCHIVE",
    "DELETE",
    "EDIT_POST_DESCRIPTION", 
];
const MultiselectMenu = (props)=>{
    const { currentlyActiveCommands , multiselectObjects  } = props;
    const { setForceMultiselect  } = useNavigationListContext();
    const close = useCallback(()=>{
        setForceMultiselect(false);
    }, [
        setForceMultiselect
    ]);
    const actions = useMemo(()=>{
        return ACTIONS.filter((action)=>currentlyActiveCommands.includes(action.command) && isActionValidForMultiselect(action, multiselectObjects)).map((action)=>action.command).sort((a, b)=>{
            return DESIRED_ACTION_ORDER.indexOf(a) - DESIRED_ACTION_ORDER.indexOf(b);
        });
    }, [
        currentlyActiveCommands,
        multiselectObjects
    ]);
    const [tiles, pills] = useMemo(()=>{
        const half = 3;
        return [
            actions.slice(0, half),
            actions.slice(half)
        ];
    }, [
        actions
    ]);
    if (actions.length === 0) return null;
    return /*#__PURE__*/ _jsx(Portal, {
        children: /*#__PURE__*/ _jsxs(MultiselectMenuWrapper, {
            bg: "blue.500",
            borderRadius: "30px",
            children: [
                /*#__PURE__*/ _jsx(CancelButton, {
                    variant: "circle-bright-blue-bg",
                    color: "white.100",
                    onClick: close,
                    children: /*#__PURE__*/ _jsx(Cancel, {})
                }),
                /*#__PURE__*/ _jsx(MultiselectMenuItemsWrapper, {
                    children: tiles.map((command)=>{
                        return /*#__PURE__*/ _jsx(MenuItemTile, {
                            action: command,
                            variant: "tile"
                        }, command);
                    })
                }),
                /*#__PURE__*/ _jsx(MultiselectMenuItemsPills, {
                    children: pills.map((command)=>{
                        return /*#__PURE__*/ _jsx(MenuItemPill, {
                            action: command,
                            variant: "pill"
                        }, command);
                    })
                })
            ]
        })
    });
};
export default MultiselectMenu;
